import type { ScaleLinear } from 'd3-scale'

import {
  AXIS_LINE_COLOR,
  AXIS_TEXT_COLOR,
  MAJOR_TICK_COLOR,
} from '@/features/bidding/components/cascading/charts/constants'

type ValueAxisProps = {
  scale: ScaleLinear<number, number>
  width: number
  formatTick?: (value: number) => string | number
}

/**
 * Y-axis positioned on the right side of the chart.
 */
function ValueAxis({ scale, width, formatTick = (v) => v }: Readonly<ValueAxisProps>) {
  const [y1, y2] = scale.range()
  const ticks = scale.ticks(5)

  return (
    <g
      className="value-axis opacity-50"
      fill="none"
      fontFamily="sans-serif"
      fontSize="10"
      style={{ pointerEvents: 'none' }}
      textAnchor="start"
      transform={`translate(${width}, 0)`}
    >
      {/* Axis line */}
      <path className="domain" d={`M0,${y1}V${y2}H0`} stroke={AXIS_LINE_COLOR} strokeWidth={0.5} />

      {/* Ticks */}
      {ticks.map((v) => (
        <g key={`valueaxis-tick-${v}`} className="tick" transform={`translate(0, ${scale(v)})`}>
          <line opacity={0.5} stroke={MAJOR_TICK_COLOR} x2={6} />
          <text dx="0.32em" fill={AXIS_TEXT_COLOR} x={6} y={3}>
            {formatTick(v)}
          </text>
        </g>
      ))}
    </g>
  )
}

export default ValueAxis
